import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  signal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-notes-dialog',
  imports: [ReactiveFormsModule, TranslatePipe],
  templateUrl: './edit-notes-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './edit-notes-dialog.component.scss',
})
export class EditNotesDialogComponent {
  public notes = signal<string>(null);
  public title = signal<string>('pricing.partner.editNotes.title');
  public placeholder = signal<string>('pricing.partner.editNotes.placeholder');
  public onSave = signal<(notes: string) => void>(null);

  protected modalRef = inject(NgbActiveModal);

  protected notesFormControl = new FormControl<string>(null);

  constructor() {
    effect(() => {
      this.notesFormControl.setValue(this.notes());
    });
  }

  protected updateNotes() {
    this.onSave()?.(this.notesFormControl.value);

    this.modalRef.close();
  }
}
